<template lang="pug">
div
    el-dialog.resultado-diagnostico(
        :visible.sync='mostrarDialogCamadas',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        fullscreen
    )
        .lista
            .lista__header
                h2.cursor-pointer(@click='limparFlags()')
                    i.el-icon-arrow-left.voltar
                    | {{ $t('mensagens.operacao.monitoramento.analiseSelecionada') }}
                BaseButton(
                    v-if='diagnosticoPessoa',
                    type='primary',
                    @click='mostrarTerritorios()'
                ) {{ $t('mensagens.operacao.monitoramento.exibirTerritorios') }}
            .lista__content
                .lista__grupo(
                    v-for='(grupo, index) in diagnosticoSelecionado.grupo'
                )
                    label.font-weight-bold
                        | {{ (grupo.codigo === 'PROXIMIDADE_CAR_ANALISADO' || grupo.codigo === 'PROXIMIDADE_TERRITORIO_ANALISADO') ? `( ${grupo.diagnostico.length} ) ` + $t(`mensagens.operacao.monitoramento.${grupo.codigo}`) : $t(`mensagens.operacao.monitoramento.${grupo.codigo || 'CAR_ANALISADO'}`) }}

                    div
                        span {{ grupo.nome }}
                    card-informacoes-gerais-car(
                        :informacoes_gerais='grupo.informacoes_gerais || grupo.informacoesGerais',
                        :refMapa='refMapa',
                        tipoPesquisa='CAR_OPERACAO',
                        v-if='grupo.titulo === "CAR Analisado"'
                    )
                    DiagnosticoSocioambiental(
                        :key='diagnosticoKey'
                        v-if='verificarDiagnosticos(grupo.diagnostico)',
                        :dadosConsulta='grupo',
                        :indexCollapse='index',
                        :cpfCnpj='grupo.documento',
                        :habilitar-sinal-aviso='grupo.territorioProximidade',
                        :habilitar-inibicao-camada='habilitarInibicaoCamada',
                        :mapaLeaflet='refMapa',
                        :habilitar-zoom-restricao='true',
                        @index-aberto='atualizarRestricaoMapa',
                        @inibir-restricao='abrirModalInibirRestricao',
                        @inibir-restricoes-em-lote='abrirModalInibirRestricoesEmLote',
                        @editar-justificativa='abrirModalEditarJustificativa'
                    )
        .mapa
            mapa(
                :showStatesLayers='false',
                :mapLayersConfigs='layersMaps',
                :mapConfig='mapConfig',
                :height='"100%"',
                :idMapa='"mapaAnaliseSocioambientalOperacao"',
                ref='mapa',
                :menuMaior='true',
                :doubleMapOnPage='true'
            )

    ModalInibirRestricoes(
        ref='modalInibirRestricao',
        :id-operacao='inibicao.idOperacao',
        :codigo-restricao='inibicao.idRestricao',
        :codigo-camada='inibicao.codigoCamada',
        @atualizar-restricao-inibido='atualizarRestricaoInibido'
    )
    ModalInibirRestricoesEmLote(
        ref='modalInibirRestricoesEmLote',
        :id-operacao='inibicaoEmLote.idOperacao',
        :restricoes-selecionadas='inibicaoEmLote.restricoesSelecionadas',
        :camada='inibicaoEmLote.camada',
        @atualizar-restricoes-inibidas='atualizarRestricoesInibidas'
    )
    ModalJustificativaRestricoes(
        ref='modalJustificativaRestricao',
        :id-operacao='inibicao.idOperacao',
        :codigo-restricao='inibicao.idRestricao'
    )
    ModalEdicaoRestricoes(
        ref='modalEdicaoRestricao',
        :id-operacao='inibicao.idOperacao',
        :codigo-restricao='inibicao.idRestricao',
        :codigo-camada='inibicao.codigoCamada'
    )
</template>

<script>
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import Mapa from '@/components/MapaLeaflet.vue';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos.js';
import ModalInibirRestricoes from '@/components/operacao/gestao/ModalInibirRestricoes.vue';
import ModalInibirRestricoesEmLote from '@/components/operacao/gestao/ModalInibirRestricoesEmLote.vue';
import ModalJustificativaRestricoes from '@/components/operacao/gestao/ModalJustificativaRestricoes.vue';
import ModalEdicaoRestricoes from '@/components/operacao/gestao/ModalEdicaoRestricoes.vue';
import L from 'leaflet';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import CardInformacoesGeraisCar from '@/components/diagnosticoSocioambiental/CardInformacoesGeraisCar.vue';

export default {
    name: 'ModalResultadoDiagnostico',
    components: {
        ModalEdicaoRestricoes,
        ModalInibirRestricoes,
        ModalInibirRestricoesEmLote,
        ModalJustificativaRestricoes,
        Mapa,
        DiagnosticoSocioambiental,
        BaseButton,
        CardInformacoesGeraisCar
    },
    emits: ['atualizarDadosMonitoramento'],
    props: {
        habilitarInibicaoCamada: {
            default: false,
            required: false
        }
    },

    data() {
        return {
            diagnosticoKey: 0,
            restricao: null,
            restricoes: null,
            inibicao: {
                idOperacao: '',
                idRestricao: '',
                codigoCamada: ''
            },
            inibicaoEmLote: {
                idOperacao: '',
                restricoesSelecionadas: [],
                camada: {}
            },
            mostrarDialogCamadas: false,
            mostrarDialogInibirRestricao: false,
            areasRestricao: [],
            diagnosticoSelecionado: [],
            collapsesAbertos: [],
            layersMaps: [],
            mapConfig: {
                controls: {
                    drawControl: false,
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    buscarCarControl: true,
                    bufferControl: false,
                    uploadFileControl: false,
                    ferramentasControl: true
                },
                historicoMonitoramento: false,
                inspecionar: true,
                diagnostico: false
            },
            territorios: [],
            territoriosExibidos: false,
            diagnosticoPessoa: false,
            refMapa: null
        };
    },

    methods: {
        verificarDiagnosticos(diagnosticos) {
            if (!diagnosticos) {
                return false;
            }

            return true;
        },
        ordenarRestricoes(camada) {
            camada.resultados.sort((a, b) => {
                if (a.inibido && b.inibido) {
                    return new Date(b.dataInibido) - new Date(a.dataInibido);
                } else if (a.inibido && !b.inibido) {
                    return -1;
                } else if (!a.inibido && b.inibido) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },
        atualizarRestricaoInibido() {
            this.restricao.inibido = true;
            this.diagnosticoSelecionado.grupo.forEach(grupo => {
                grupo.diagnostico.forEach(camada => {
                    camada.resultados
                        .filter(resultado => resultado.id === this.restricao.id)
                        .forEach(camadaIgual => {
                            camadaIgual.dataInibido = this.obterDataAtualInibida();
                            camadaIgual.inibido = true;
                        });

                    if (camada.resultados.some(r => r.id === this.restricao.id)) {
                        this.ordenarRestricoes(camada);
                    }
                });
            });

            this.diagnosticoKey++;
            this.$emit('atualizarDadosMonitoramento');
        },
        atualizarRestricoesInibidas(restricoes) {
            this.restricoes = restricoes;
            this.restricoes.forEach(restricao => {
                restricao.inibido = true;
                restricao.dataInibido = this.obterDataAtualInibida();

                this.diagnosticoSelecionado.grupo.forEach(grupo => {
                    grupo.diagnostico.forEach(camada => {
                        const restricaoEncontrada = camada.resultados.find(
                            resultado => resultado.id === restricao.id
                        );
                        if (restricaoEncontrada) {
                            restricaoEncontrada.inibido = true;
                            restricaoEncontrada.dataInibido = restricao.dataInibido;

                            this.ordenarRestricoes(camada);
                        }
                    });
                });
            });

            this.diagnosticoKey++;
            this.$emit('atualizarDadosMonitoramento');
        },
        obterDataAtualInibida() {
            return new Date().toISOString();
        },
        atualizarRestricaoMapa(restricao, indexGrupo, indexCamada) {
            if (indexCamada === null || indexCamada === '') {
                this.layersMaps = this.layersMaps.filter(l => l.name === 'territorio');
                return;
            }

            this.layersMaps = this.layersMaps.filter(
                l => !l.name.startsWith('bufferProximidadeCAR-') && !l.name.startsWith('proximidade-')
            );

            const grupoSelecionado = this.diagnosticoSelecionado.grupo[indexGrupo];

            if (grupoSelecionado.proximidadeBuffer) {
                grupoSelecionado.diagnostico.forEach(diagnosticoItem => {
                    if (diagnosticoItem.geometriaProximidade) {
                        this.layersMaps.push({
                            style: getEstiloGeometria('areaProximidade'),
                            geoJson: diagnosticoItem.geometriaProximidade,
                            name: `bufferProximidade-${grupoSelecionado.nome}-${indexGrupo}`
                        });
                    }
                });
            }

            if (grupoSelecionado.territorioProximidade) {
                const nomeTerritorioProximidade = `proximidade-territorio-${grupoSelecionado.nome}-${indexGrupo}`;
                if (!this.layersMaps.find(l => l.name === nomeTerritorioProximidade)) {
                    this.layersMaps.push({
                        style: getEstiloGeometria('areaProximidade'),
                        geoJson: this.diagnosticoSelecionado.territorioGeometria,
                        name: nomeTerritorioProximidade
                    });
                }
            }

            if (grupoSelecionado.codigo === 'CAR_ANALISADO') {
                const layerName = `area-car-${grupoSelecionado.nome}`;
                const existingLayer = this.layersMaps.find(layer => layer.name === layerName);
            
                if (!existingLayer) {
                    let geoJsonData = grupoSelecionado.informacoes_gerais?.geometria || grupoSelecionado.informacoesGerais?.geometria;

                    if (typeof geoJsonData === 'string') {
                        geoJsonData = JSON.parse(geoJsonData);
                    }

                    this.layersMaps.push({
                        style: getEstiloGeometria('carHighlight'),
                        geoJson: geoJsonData,
                        name: layerName
                    });
                }
            }

            if (grupoSelecionado.codigo === 'PROXIMIDADE_CAR_ANALISADO') {
                const nomeTerritorio = `area-car-${grupoSelecionado.nome}-${indexGrupo}`;
                if (!this.layersMaps.find(l => l.name === nomeTerritorio)) {
                    let geoJsonData = grupoSelecionado.geometriaDoCar;
                    if (typeof geoJsonData === 'string') {
                        geoJsonData = JSON.parse(geoJsonData);
                    }

                    this.layersMaps.push({
                        style: getEstiloGeometria('areaProximidade'),
                        geoJson: geoJsonData,
                        name: nomeTerritorio
                    });
                }
            }

            if (grupoSelecionado.codigo === 'AREA_ANALISADA') {
                if (!this.layersMaps.find(l => l.name === 'territorio')) {
                    this.layersMaps.push({
                        style: getEstiloGeometria('operacaoTerritorio'),
                        geoJson:
                            this.diagnosticoSelecionado.territorioGeometria,
                        name: 'territorio'
                    });
                }
            }

            this.areasRestricao = [];

            /**
             * Remove o último quando for dentro do mesmo collapse
             */
            const mesmogGrupo = this.collapsesAbertos.find(
                c => c.indexGrupo === indexGrupo
            );
            if (mesmogGrupo) {
                this.layersMaps = this.layersMaps.filter(
                    l => l.tagRestricao !== mesmogGrupo.tag
                );
                this.collapsesAbertos = this.collapsesAbertos.filter(
                    l => l.tag !== mesmogGrupo.tag
                );
            }

            /**
             * Quando possuir indexCamada é por que o collapse está sendo aberto
             * Nesse caso a geometria é adicionada no mapa
             */
            if (indexCamada !== '') {
                const grupoSelecionado =
                    this.diagnosticoSelecionado.grupo[indexGrupo];
                const diagnosticoSelecionado =
                    grupoSelecionado.diagnosticos ||
                    grupoSelecionado.diagnostico;
                this.areasRestricao = diagnosticoSelecionado[
                    indexCamada
                ].resultados.filter(
                    resultado => resultado.geometria || resultado.geometry
                );

                const tagRestricaoAdd = `${indexGrupo}-${indexCamada}-restricao`;
                this.collapsesAbertos.push({
                    indexGrupo,
                    indexCamada,
                    tag: tagRestricaoAdd
                });

                this.mostrarAreasDiagnosticoNoMapa(tagRestricaoAdd, restricao);
            }
        },

        abrirModal(diagnosticoProtocolo) {
            this.mostrarDialogCamadas = true;
            this.layersMaps = [];
            this.areasRestricao = [];
            this.collapsesAbertos = [];
            this.diagnosticoSelecionado = null;
            this.territorios = diagnosticoProtocolo.territorios;
            this.diagnosticoPessoa = diagnosticoProtocolo.diagnosticoPessoa;

            this.$nextTick(() => {
                this.refMapa = this.$refs.mapa;
            });

            diagnosticoProtocolo.grupo.forEach(grupo => {
                
                grupo.diagnostico.sort((a, b) => {
                    const nomeA = this.$t(`mensagens.camadas.${a.camada.codigo}`);
                    const nomeB = this.$t(`mensagens.camadas.${b.camada.codigo}`);
                    return nomeA.localeCompare(nomeB);
                });
                
                const statusCAR = grupo.diagnostico.filter(d => d.camada?.codigo === 'SITUACAO_CAR_SANTANDER');
    
                if (statusCAR.length) {
                    grupo.diagnostico = grupo.diagnostico.filter(d => d.camada?.codigo !== 'SITUACAO_CAR_SANTANDER');
                    grupo.diagnostico.unshift(statusCAR[0]);
                }
            });

            this.diagnosticoSelecionado = diagnosticoProtocolo;

            this.adicionaGeometriasFixasNoMapa(diagnosticoProtocolo);
        },

        abrirModalEditarJustificativa(restricao, diagnostico) {
            this.mostrarDialogInibirRestricao = true;

            this.inibicao.idRestricao = restricao.id;
            this.inibicao.codigoCamada = diagnostico.camada.codigo;
            this.inibicao.idOperacao = this.$route.params.id;
            this.$refs.modalEdicaoRestricao.mostrarDialog = true;
        },

        mostrarTerritorios() {
            if (this.territoriosExibidos) {
                this.layersMaps = this.layersMaps.filter(
                    l => !l.name.includes('territorio-')
                );
            }

            this.territorios.forEach(territorio => {
                this.layersMaps.push({
                    name: `territorio-${territorio.id}`,
                    geoJson: territorio.geometria,
                    style: getEstiloGeometria('operacaoTerritorio')
                });
            });
            this.territoriosExibidos = true;
        },

        limparFlags() {
            this.mostrarDialogCamadas = false;
            this.territoriosExibidos = false;
            this.diagnosticoPessoa = false;
        },

        adicionaGeometriasFixasNoMapa(diagnosticoProtocolo) {
            if (diagnosticoProtocolo.territorioGeometria) {
                this.layersMaps.push({
                    style: getEstiloGeometria('operacaoTerritorio'),
                    geoJson: diagnosticoProtocolo.territorioGeometria,
                    name: 'territorio'
                });
            }

            if (diagnosticoProtocolo.glebaGeometria) {
                const idStyle = diagnosticoProtocolo.utilizouAreaTotalTerritorio
                    ? 'operacaoGlebaAreaTotalTerritorio'
                    : 'operacaoGleba';

                this.layersMaps.push({
                    style: getEstiloGeometria(idStyle),
                    geoJson: diagnosticoProtocolo.glebaGeometria,
                    name: idStyle
                });
            }
        },

        abrirModalInibirRestricoesEmLote(restricoes, diagnostico) {
            this.inibicaoEmLote.restricoesSelecionadas = restricoes.map(
                restricao => ({ ...restricao, operacoes: [] })
            );
            this.inibicaoEmLote.camada = diagnostico.camada;
            this.inibicaoEmLote.idOperacao = this.$route.params.id;
            this.$refs.modalInibirRestricoesEmLote.mostrarDialog = true;
        },

        abrirModalInibirRestricao(restricao, diagnostico) {
            this.restricao = restricao;

            if (!restricao.inibido) {
                this.inibicao.idRestricao = restricao.id;
                this.inibicao.codigoCamada = diagnostico.camada.codigo;
                this.inibicao.idOperacao = this.$route.params.id;
                this.$refs.modalInibirRestricao.mostrarDialog = true;
            } else {
                this.inibicao.idRestricao = restricao.id;
                this.inibicao.idOperacao = this.$route.params.id;
                this.$refs.modalJustificativaRestricao.mostrarDialog = true;
            }
        },

        mostrarAreasDiagnosticoNoMapa(tagRestricao, restricao) {
            this.areasRestricao.forEach((area, index) => {
                const geometria = area.geometria || area.geometry;

                const pin = L.icon({
                    iconUrl: 'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                    iconSize: [18, 18]
                });

                this.layersMaps.push({
                    name: `CentroidDiagnostico_${index}`,
                    icon: pin,
                    geoJson: centroidFromGeoJSON.get(geometria)
                });

                let layerAreaDiagnostico;
                if (
                    restricao &&
                    restricao.index === index &&
                    restricao.overOrLeave === 'over'
                ) {
                    layerAreaDiagnostico = {
                        style: {
                            color: 'orange',
                            weight: 1,
                            fill: true,
                            fillOpacity: 0.5
                        },
                        name: `AreaDiagnostico ${index}`,
                        tagRestricao,
                        geoJson: geometria
                    };
                } else {
                    layerAreaDiagnostico = {
                        style: {
                            color: 'red',
                            weight: 1,
                            fill: true,
                            fillOpacity: 0.5
                        },
                        name: `AreaDiagnostico ${index}`,
                        tagRestricao,
                        geoJson: geometria
                    };
                }
                if (geometria.type !== 'Point') {
                    this.layersMaps.push(layerAreaDiagnostico);
                }
            });
        }
    }
};
</script>

<style lang="scss">
.resultado-diagnostico {
    .custon-icon {
        font-size: 16px;
    }

    .custon-icon-el {
        font-size: 18px;
    }
    .lista {
        display: flex;
        flex-direction: column;
        width: 35%;
        gap: 20px;
        max-height: 100vh;
        padding: 20px 10px 20px 20px;

        .lista__header {
            .voltar {
                cursor: pointer;
                margin-right: 10px;
            }

            h2 {
                color: var(--primary-font-color);
            }
        }

        .lista__content {
            display: flex;
            flex-direction: column;
            gap: 20px;
            height: 90vh;
            overflow-y: scroll;
        }

        .lista__grupo {
            label {
                color: var(--primary);
            }
        }
    }

    .mapa {
        width: 100%;
        height: 100vh;
        border-radius: 0;
    }

    .el-dialog__body {
        display: flex;
        padding: initial !important;
    }

    .el-dialog__header {
        padding: initial;
    }
}
</style>
